
export const contextBarViewerShared = {

  idDOM: '#top-menu-section-view',

  element: function () {

    return jQuery(contextBarViewerShared.idDOM);

  },

  clear: function () {

    contextBarViewerShared.element().empty();

  },

  hide: function () {

    contextBarViewerShared.element().hide();

  },

  show: function () {

    contextBarViewerShared.element().show();

  },

  elements: {

    labelTool: function (name) {

        var $labelDiv = $('<div class="menu-document-label"></div>');

        var $nameLabel = $('<div class="name-document"></div>');
        $nameLabel.html(name);
        $labelDiv.append($nameLabel);

        return $labelDiv;
    },

  },

  create: function (name) {

    contextBarViewerShared.clear();

    contextBarViewerShared.element().append(contextBarViewerShared.elements.labelTool(name));

  },

};
